/**
 * Maps the VBC account type to the account type and payment account type.
 * @param vbcAccountType - The VBC account type.
 * @returns The account type and payment account type.
 */
export var mapAccountType = function mapAccountType(vbcAccountType) {
  var accountType;
  var paymentAccountType;
  switch (vbcAccountType) {
    case 'CREDIT_CARD':
      accountType = 'credit card';
      paymentAccountType = 'CREDIT_CARD_TOKEN';
      break;
    case 'PAYPAL':
    case 'BRAINTREE_V_ZERO':
      accountType = 'paypal token';
      paymentAccountType = 'PAYPAL_TOKEN';
      break;
    case 'APPLE_PAY':
    case 'BRAINTREE_APPLE_PAY':
      accountType = 'apple pay';
      paymentAccountType = 'APPLE_PAY';
      break;
    case 'VENMO':
      accountType = 'venmo';
      paymentAccountType = 'venmo';
      break;
    default:
      accountType = vbcAccountType;
      paymentAccountType = vbcAccountType;
  }
  return {
    accountType: accountType,
    paymentAccountType: paymentAccountType
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/nextInteractionUtil/getMopAccountType.js
// module id = 4159
// module chunks = 11